export default __webpack_public_path__ + "static/media/lentes-pasta.72e19258.png";